module.exports = __webpack_public_path__ + "img/figure5.51c89973.svg";